import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const PhoneOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M14.98 20.75c-2.51 0-5.11-1.52-7.72-4.53-2.64-3.03-3.78-5.83-3.4-8.34.32-2.13 1.63-3.28 2.18-3.68l.47-.41c.49-.42 1-.6 1.53-.52.88.13 1.5.94 1.95 1.63l.42.65c.39.61 1.58 2.47-.04 3.88l-.58.5c-.07.06-.15.12-.25.18-.26.17-.39.28-.41.47-.03.24.05.99 1.53 2.69s2.21 1.89 2.46 1.89c.19 0 .31-.11.52-.34.08-.09.15-.16.22-.22l.57-.5c1.63-1.41 3.3.03 3.85.5l.58.5c.62.53 1.34 1.26 1.34 2.15 0 .53-.24 1.02-.73 1.44l-.52.45c-.43.44-1.75 1.58-3.9 1.6h-.07v.01ZM7.81 4.69c-.11 0-.25.1-.36.19l-.51.45c-.45.33-1.41 1.19-1.65 2.77-.31 2.06.72 4.48 3.07 7.18 2.34 2.7 4.59 4.01 6.68 4.03 1.61-.02 2.58-.85 2.93-1.21l.56-.49c.11-.09.24-.23.24-.35 0-.1-.08-.42-.84-1.07l-.58-.5c-1.19-1.01-1.63-.81-1.97-.51l-.57.5s-.06.06-.09.1c-.24.27-.76.8-1.6.82-1 0-2.12-.77-3.53-2.38-1.41-1.62-2-2.83-1.87-3.83.11-.86.74-1.27 1.04-1.47.04-.03.08-.05.11-.07l.57-.5c.35-.3.61-.71-.23-2.02l-.42-.65c-.52-.81-.81-.96-.94-.98h-.03l-.01-.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default PhoneOutlined
